export default "__VITE_ASSET__edcca271__"